import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/index.vue"),
  },
  {
    path: "/game",
    name: "game",
    component: () => import("@/views/Game/index.vue"),
  },
  {
    path: "/about_us",
    name: "about_us",
    component: () => import("@/views/About/index.vue"),
  },
  {
    path: "/contact_us",
    name: "contact_us",
    component: () => import("@/views/Contact/index.vue"),
  },
  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/policy.vue"),
  },
  {
    path: "/checkoutnow",
    name: "checkoutnow",
    component: () => import("@/views/checkoutnow.vue"),
  },
  // 404 页面
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/home",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next();
});

export default router;
